var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgResearch = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 21,
  viewBox: "0 0 19 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.5231 16.7846V16.7846C11.5231 17.8671 10.9362 18.8645 9.98994 19.3902L9.36558 19.7371C9.05519 19.9095 8.70597 20 8.3509 20V20C7.19698 20 6.26154 19.0646 6.26154 17.9106V12.4734C6.26154 11.6778 5.94547 10.9147 5.38286 10.3521L1.87868 6.84791C1.31607 6.2853 1 5.52224 1 4.72659V4C1 2.34314 2.34315 1 4 1H14.6615C16.3184 1 17.6615 2.34315 17.6615 4V4.72659C17.6615 5.52224 17.3455 6.2853 16.7829 6.84791L16.4923 7.13846",
  stroke: "currentColor",
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9923 11.5231C15.9923 13.3456 14.5149 14.8231 12.6923 14.8231C10.8698 14.8231 9.39233 13.3456 9.39233 11.5231C9.39233 9.70054 10.8698 8.22308 12.6923 8.22308C14.5149 8.22308 15.9923 9.70054 15.9923 11.5231Z",
  stroke: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.0308 13.8615L16.7846 15.6154",
  stroke: "currentColor",
  strokeLinecap: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgResearch);
export { ForwardRef as ReactComponent };